/* RESPONSIBLE TEAM: team-inbox */
import Model, { attr } from '@ember-data/model';

export default class CopilotSettings extends Model {
  @attr('array') declare trustedAdminIds: number[];
  @attr('boolean') declare usePastConversations: boolean;
  @attr('boolean') declare useMacros: boolean;
  @attr() declare excerptMatchingAttributes?: {
    attributes: { identifier: string; type: string }[];
    type: string;
  };
}
